import mutations from '@fps/vue-toolkit/dist/store/auth/auth.mutationlist';

export default Object.assign({}, mutations, {
});



// WEBPACK FOOTER //
// ./src/store/auth/auth.mutationlist.js